import AlertsTable from "./AlertsTable"
import { Button } from '@mui/material'
import Modal from "./Modal"
import { useProject } from "../context/project"

export default function AlertsBoard({open, setOpen, setOpenAlert, setAlertToEdit}) {
    const {ticker} = useProject()

    const closeAlertsBoard = () => setOpen(false)

    const openAlertWindow = () => {
        setOpen(false)
        setOpenAlert(true)
    }

    const buttons = [
        <Button key="cancel" variant="outlined" onClick={closeAlertsBoard}>Cancel</Button>,
        <Button key="set-alert" variant="contained" color="active" onClick={openAlertWindow}>+Add Alert</Button>,
    ]

    return (
        <Modal open={open} handleClose={closeAlertsBoard} title={`${ticker} Alerts`} buttons={buttons}>
            <AlertsTable setAlertToEdit={setAlertToEdit} openAlertWindow={openAlertWindow}/>
        </Modal>
    )
}